import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import { DialogService } from '@progress/kendo-angular-dialog';
import { NotificationService } from '@progress/kendo-angular-notification';
import { SVGIcon, plusIcon } from '@progress/kendo-svg-icons';
import { Observable, combineLatest, startWith, takeUntil } from 'rxjs';
import { DashboardResponse } from 'src/app/modules/dashboard/interface/dashboard-response';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { AssessmentService } from 'src/app/modules/evaluations/assessment/services/assessment.services';
import { EvaluationService } from 'src/app/modules/evaluations/services/evaluation.service';
import { iepSections } from 'src/app/modules/iep/iep-document/constants/iep-sections';
import { IEPService } from 'src/app/modules/iep/iep-document/services/iep.services';
import { SCHEDULE_MEETING_CONSTANTS } from 'src/app/modules/student-info/schedule-meeting/schedule-meeting-constants';
import { StudentService } from 'src/app/services/student.service';
import { AbstractForm } from 'src/app/shared/components/abstract-form';
import { ISedmsFormModel } from 'src/app/shared/interfaces/form/sedms-form-model';
import { AuthStore } from 'src/app/stores/auth.store';
import { ReferenceStore } from 'src/app/stores/reference.store';
import {
  IN_REACH,
  OUTREACH_METHOD_HOME_VISIT,
  OUTREACH_METHOD_SCHOOL_VISIT,
  OUT_OF_COMPLIANCE,
  TWO_YEARS_DATE_COUNT,
  YES_VALUE,
} from '../../constants/case-close';
import { FormControls, FormSection } from '../../enums/case-close';
import { ReasonForDelayId } from '../../enums/reason-for-delay';
import { ConsentDateResponse } from '../../interfaces/consent-date-response';
import { CaseCloseReferenceData } from '../../interfaces/form/case-closing-refernce-data-model';
import { IReferenceData } from '../../interfaces/form/reference-data.model';
import { AddCaseClosingFormModel } from '../../models/case-close-model/case-close-formmodel';
import { SubmitCaseClosingModel } from '../../models/case-close-model/submit-case-close-model';
import { SudentRelatedEventsModel } from '../../models/student-related-events-models/student-related-event-response-model';
import { User } from '../../models/user';
import { ContributorService } from '../../services/contributor-service';
import { StudentProfile } from '../../interfaces/student-profile';
import { ReasonForDelayComponent } from '../reason-for-delay/reason-for-delay.component';

@Component({
  selector: 'app-case-closing',
  templateUrl: './case-closing.component.html',
  styleUrls: ['./case-closing.component.scss'],
  standalone: false,
})
export class CaseClosingComponent
  extends AbstractForm<
    SudentRelatedEventsModel,
    SudentRelatedEventsModel,
    Record<string, IReferenceData[]>
  >
  implements OnChanges
{
  @ViewChild(ReasonForDelayComponent) rfdComponent: ReasonForDelayComponent;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  @Input() stdentDetails: any;
  @Input() studentDob: any;
  @Input() studentSk: string;
  @Input() referralSk: string;
  @Input() complianceStatus: string;
  @Input() activity: string;
  @Input() eiId: string;
  selectedAction: string;
  loadSpinner: boolean;
  timePickerValue: Date = SCHEDULE_MEETING_CONSTANTS.timePickerDefaultValue;
  showPreviousAttemptsBtn: boolean;
  dropDownValues: IReferenceData[];
  showToPhone: boolean;
  showToEmail: boolean;
  showToPostal: boolean;
  studentDetails: StudentProfile;
  showFromEmail: boolean;
  showFromPhone: boolean;
  showFromPostal: boolean;
  showParentAndPrincipal: boolean;
  showFinalNoticeEvaluationProcess: boolean;
  showPhoneOutreach: boolean;
  showPlaceMent: boolean;
  show45: boolean;
  showRevocationConsent: boolean;
  showElapsed: boolean;
  showIneligibilityLetter: boolean;
  showPwnRecommendation: boolean;
  showDeclassificationDocument: boolean;
  showProjectedDate: boolean;
  showDeclassificationParent: boolean;
  showDischargeReasons: boolean;
  showDischargeDetails: boolean;
  ImpartialHearing: boolean;
  public format: FormatSettings = {
    displayFormat: 'MM/dd/yyyy',
    inputFormat: 'MM/dd/yyyy',
  };
  minDate: Date;
  maxDate: Date;
  defaultDate: Date;
  dueDate: string;
  iepFormSk: string;
  user: User;
  finalizeShown: boolean = true;
  form: FormGroup;
  formModel: ISedmsFormModel = AddCaseClosingFormModel;
  showOtherInput: boolean;
  locked: boolean = false;
  frequencyData = [];
  userDetails: User;
  showReasonForDelay: boolean = false;
  svgPlus: SVGIcon = plusIcon;
  reasonForDelayList: any;
  ConsentDate: any;
  readonly yes: string = YES_VALUE;

  constructor(
    private fb: FormBuilder,
    public services: AssessmentService<any>,
    private authStore: AuthStore,
    notificationService: NotificationService,
    private dashboardService: DashboardService,
    private studentService: StudentService,
    private referenceStore: ReferenceStore,
    private evaluationService: EvaluationService<any>,
    private iepService: IEPService<any>,
    private service: ContributorService,
    dialogService: DialogService,
    cdRef: ChangeDetectorRef,
    route: ActivatedRoute,
    formBuilder: FormBuilder,
    public activatedRoute: ActivatedRoute
  ) {
    super(cdRef, route, formBuilder, dialogService, notificationService);
    this.user = this.authStore.UserInfo;

    this.authStore.UserInfo$.pipe(takeUntil(this.componentDestroyed)).subscribe(
      (userInfo: User) => {
        this.userDetails = userInfo;
      }
    );
    this.loadSpinner = true;
    const today: Date = new Date();
    this.defaultDate = today;
    this.minDate = new Date(
      today.getFullYear() - TWO_YEARS_DATE_COUNT,
      today.getMonth(),
      today.getDate()
    );
    this.maxDate = new Date(
      today.getFullYear() + TWO_YEARS_DATE_COUNT,
      today.getMonth(),
      today.getDate()
    );
  }

  get entity$(): Observable<SudentRelatedEventsModel> {
    return this.iepService.get(
      this.entityId,
      iepSections.iEPReportingToParents
    );
  }

  // For Getting Data from Dropdown
  get referenceData$(): Observable<IReferenceData[][]> {
    return combineLatest([
      this.referenceStore.caseCloseReason$,
      this.referenceStore.dischargeReason$,
      this.referenceStore.reasonForDelay$,
    ]);
  }

  initEntity(
    entityData: unknown,
    referenceData: Record<string, IReferenceData[]>
  ): SudentRelatedEventsModel {
    return new SudentRelatedEventsModel(entityData, referenceData);
  }

  initReferenceData([caseCloseReason, dischargeReason, reasonForDelay]: [
    IReferenceData[],
    IReferenceData[],
    IReferenceData[]
  ]): CaseCloseReferenceData {
    return { caseCloseReason, dischargeReason, reasonForDelay };
  }

  get getOutreachMetod(): IReferenceData[] {
    if (this.selectedAction === IN_REACH) {
      return this.referenceData.outreachMethod.filter(
        (data) =>
          data.id !== OUTREACH_METHOD_HOME_VISIT &&
          data.id !== OUTREACH_METHOD_SCHOOL_VISIT
      );
    } else {
      return this.referenceData.outreachMethod;
    }
  }

  initWatches(): void {
    this.loadSpinner = true;
    this.evaluationService
      .getConsentDate(this.referralSk)
      .subscribe((res: ConsentDateResponse) => {
        this.ConsentDate = res?.consentDate;
        this.dueDate = res.dueDate ?? null;
        this.loadSpinner = false;
      });

    this.loadSpinner = false;

    this.form
      .get('reason')
      ?.valueChanges.pipe(
        takeUntil(this.componentDestroyed),
        startWith(this.form.get('reason')?.value),
      )
      .subscribe((value: number) => {
        this.handleReasonChange(value);
      });
    this.form
      .get('requiresImpartial')
      ?.valueChanges.pipe(
        takeUntil(this.componentDestroyed),
        startWith(this.form.get('requiresImpartial')?.value),
      )
      .subscribe(() => {});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.studentDob?.currentValue) {
      const details: DashboardResponse = changes.studentDob?.currentValue;

      if (details?.nycid) {
        this.nycId = details.nycid;
        this.getStudentDetails();
      }
    }
  }

  getStudentDetails(): void {
    if (this.nycId) {
      this.studentService.studentProfile(this.nycId).subscribe({
        next: (response: StudentProfile) => {
          this.studentDetails = response;
        },
      });
    }
  }

  handleReasonChange(reasonId: number | undefined): void {
    this.resetFormControls();

    switch (reasonId) {
      case ReasonForDelayId.ParentAndPrincipal:
        this.showParentAndPrincipal = true;
        this.form.controls.referral.setValidators([Validators.requiredTrue]);
        this.updateFormControlsValidity('referral');

        break;
      case ReasonForDelayId.FinalNoticeReferredElsewhere:
      case ReasonForDelayId.FinalNoticeLackOfConsent:
      case ReasonForDelayId.FinalNoticeStudentMoved:
      case ReasonForDelayId.FinalNoticeIEPEnded:
        this.showFinalNoticeEvaluationProcess = true;
        this.form.controls.withdrawal.setValidators([Validators.requiredTrue]);
        this.updateFormControlsValidity('withdrawal');
        break;
      case ReasonForDelayId.PhoneOutreach:
        this.showPhoneOutreach = true;
        this.showFinalNoticeEvaluationProcess = true;
        this.form.controls.withdrawal.setValidators([Validators.requiredTrue]);
        this.form.controls.phone.setValidators([Validators.requiredTrue]);
        this.updateFormControlsValidity('withdrawalPhone');
        break;
      case ReasonForDelayId.PlacementSignature:
        this.showPlaceMent = true;
        this.form.controls.placement.setValidators([Validators.requiredTrue]);
        this.updateFormControlsValidity('placement');
        break;
      case ReasonForDelayId.Placement45DayOutreach:
        this.showPlaceMent = true;
        this.show45 = true;
        this.form.controls.placement.setValidators([Validators.requiredTrue]);
        this.form.controls.outreachDays.setValidators([
          Validators.requiredTrue,
        ]);
        this.updateFormControlsValidity('placementOutreachDays');
        break;
      case ReasonForDelayId.RevocationConsentElapsed:
        this.showRevocationConsent = true;
        this.showElapsed = true;
        this.form.controls.revocationConsent.setValidators([
          Validators.requiredTrue,
        ]);
        this.form.controls.elapsed.setValidators([Validators.requiredTrue]);
        this.updateFormControlsValidity('revocationConsentElapsed');
        break;
      case ReasonForDelayId.IneligibilityLetterPWN:
        this.showIneligibilityLetter = true;
        this.showPwnRecommendation = true;
        this.form.controls.ineligibilityLetter.setValidators([
          Validators.requiredTrue,
        ]);
        this.form.controls.pwnRecommendation.setValidators([
          Validators.requiredTrue,
        ]);
        this.updateFormControlsValidity('ineligibilityLetterPwnRecommendation');
        break;
      case ReasonForDelayId.Declassification:
        this.showDeclassificationDocument = true;
        this.showProjectedDate = true;
        this.showDeclassificationParent = true;
        this.form.controls.declassificationDocument.setValidators([
          Validators.requiredTrue,
        ]);
        this.form.controls.projectedDate.setValidators([
          Validators.requiredTrue,
        ]);
        this.form.controls.declassificationParent.setValidators([
          Validators.requiredTrue,
        ]);
        this.updateFormControlsValidity(
          'declassificationProjectedDeclassification'
        );
        break;
      case ReasonForDelayId.Discharge:
        this.showDischargeDetails = true;
        this.form.controls.dischargeDate.setValidators([Validators.required]);
        this.form.controls.dischargeReason.setValidators([Validators.required]);
        this.updateFormControlsValidity('dischargeDateDischargeReason');
        break;
    }
    this.cdRef.detectChanges();
  }

  closeCaseSubmit(): void {
    if (this.stdentDetails?.rfd && this.rfdComponent) {
      this.rfdComponent.save();
    } else {
      this.submit();
    }
  }

  closeDailog(): void {
    this.close.next();
  }

  resetFormControls(): void {
    this.showParentAndPrincipal = false;
    this.showFinalNoticeEvaluationProcess = false;
    this.showPhoneOutreach = false;
    this.showPlaceMent = false;
    this.show45 = false;
    this.showRevocationConsent = false;
    this.showElapsed = false;
    this.showIneligibilityLetter = false;
    this.showPwnRecommendation = false;
    this.showDeclassificationDocument = false;
    this.showProjectedDate = false;
    this.showDeclassificationParent = false;
    this.showDischargeReasons = false;
    this.showDischargeDetails = false;
  }

  updateFormControlsValidity(data: string): void {
    let notMandatoryFields: string[];
    switch (data) {
      case FormSection.Referral:
        notMandatoryFields = [
          FormControls.Withdrawal,
          FormControls.Phone,
          FormControls.Placement,
          FormControls.OutreachDays,
          FormControls.RevocationConsent,
          FormControls.Elapsed,
          FormControls.IneligibilityLetter,
          FormControls.PwnRecommendation,
          FormControls.DeclassificationDocument,
          FormControls.ProjectedDate,
          FormControls.DeclassificationParent,
          FormControls.DischargeReason,
          FormControls.DischargeDate,
        ];
        break;
      case FormSection.Withdrawal:
        notMandatoryFields = [
          FormControls.Referral,
          FormControls.Phone,
          FormControls.Placement,
          FormControls.OutreachDays,
          FormControls.RevocationConsent,
          FormControls.Elapsed,
          FormControls.IneligibilityLetter,
          FormControls.PwnRecommendation,
          FormControls.DeclassificationDocument,
          FormControls.ProjectedDate,
          FormControls.DeclassificationParent,
          FormControls.DischargeReason,
          FormControls.DischargeDate,
        ];
        break;
      case FormSection.WithdrawalPhone:
        notMandatoryFields = [
          FormControls.Referral,
          FormControls.Placement,
          FormControls.OutreachDays,
          FormControls.RevocationConsent,
          FormControls.Elapsed,
          FormControls.IneligibilityLetter,
          FormControls.PwnRecommendation,
          FormControls.DeclassificationDocument,
          FormControls.ProjectedDate,
          FormControls.DeclassificationParent,
          FormControls.DischargeReason,
          FormControls.DischargeDate,
        ];
        break;
      case FormSection.Placement:
        notMandatoryFields = [
          FormControls.Referral,
          FormControls.Withdrawal,
          FormControls.Phone,
          FormControls.OutreachDays,
          FormControls.RevocationConsent,
          FormControls.Elapsed,
          FormControls.IneligibilityLetter,
          FormControls.PwnRecommendation,
          FormControls.DeclassificationDocument,
          FormControls.ProjectedDate,
          FormControls.DeclassificationParent,
          FormControls.DischargeReason,
          FormControls.DischargeDate,
        ];
        break;
      case FormSection.PlacementOutreachDays:
        notMandatoryFields = [
          FormControls.Referral,
          FormControls.Withdrawal,
          FormControls.Phone,
          FormControls.RevocationConsent,
          FormControls.Elapsed,
          FormControls.IneligibilityLetter,
          FormControls.PwnRecommendation,
          FormControls.DeclassificationDocument,
          FormControls.ProjectedDate,
          FormControls.DeclassificationParent,
          FormControls.DischargeReason,
          FormControls.DischargeDate,
        ];
        break;
      case FormSection.RevocationConsentElapsed:
        notMandatoryFields = [
          FormControls.Referral,
          FormControls.Withdrawal,
          FormControls.Phone,
          FormControls.Placement,
          FormControls.OutreachDays,
          FormControls.IneligibilityLetter,
          FormControls.PwnRecommendation,
          FormControls.DeclassificationDocument,
          FormControls.ProjectedDate,
          FormControls.DeclassificationParent,
          FormControls.DischargeReason,
          FormControls.DischargeDate,
        ];
        break;
      case FormSection.IneligibilityLetterPwnRecommendation:
        notMandatoryFields = [
          FormControls.Referral,
          FormControls.Withdrawal,
          FormControls.Phone,
          FormControls.Placement,
          FormControls.OutreachDays,
          FormControls.RevocationConsent,
          FormControls.Elapsed,
          FormControls.DeclassificationDocument,
          FormControls.ProjectedDate,
          FormControls.DeclassificationParent,
          FormControls.DischargeReason,
          FormControls.DischargeDate,
        ];
        break;
      case FormSection.DeclassificationProjectedDeclassification:
        notMandatoryFields = [
          FormControls.Referral,
          FormControls.Withdrawal,
          FormControls.Phone,
          FormControls.Placement,
          FormControls.OutreachDays,
          FormControls.RevocationConsent,
          FormControls.Elapsed,
          FormControls.IneligibilityLetter,
          FormControls.PwnRecommendation,
          FormControls.DischargeReason,
          FormControls.DischargeDate,
        ];
        break;
      case FormSection.DischargeDateDischargeReason:
        notMandatoryFields = [
          FormControls.Referral,
          FormControls.Withdrawal,
          FormControls.Phone,
          FormControls.Placement,
          FormControls.OutreachDays,
          FormControls.RevocationConsent,
          FormControls.Elapsed,
          FormControls.IneligibilityLetter,
          FormControls.PwnRecommendation,
          FormControls.DeclassificationDocument,
          FormControls.ProjectedDate,
          FormControls.DeclassificationParent,
        ];
        break;
    }
    for (const controlName of notMandatoryFields) {
      const control: FormControl = this.form.controls[
        controlName
      ] as FormControl;
      if (control) {
        if (control.enabled) {
          this.clearRequiredValidators(control);
        }
      }
    }

    this.cdRef.detectChanges();
  }

  //Nowhere calling the below method no sure? what will be the data type for value parameter.
  updateCheckBoxValidity(value): void {
    const checkboxNames: string[] = [
      FormControls.Referral,
      FormControls.Withdrawal,
      FormControls.Phone,
      FormControls.Placement,
      FormControls.OutreachDays,
      FormControls.RevocationConsent,
      FormControls.Elapsed,
      FormControls.IneligibilityLetter,
      FormControls.PwnRecommendation,
      FormControls.DeclassificationDocument,
      FormControls.ProjectedDate,
      FormControls.DeclassificationParent,
      FormControls.DischargeReasons,
    ];

    checkboxNames.forEach((name: string) => {
      if (value[name]) {
        this.form.controls[name].setValidators([Validators.required]);
      } else {
        this.form.controls[name].clearValidators();
      }
      this.form.controls[name].updateValueAndValidity();
    });
  }

  public override otherInitalizations(): void {
    if (this.complianceStatus === OUT_OF_COMPLIANCE) {
      this.form.get('reason').addValidators([Validators.required]);
      this.form.get('reason').updateValueAndValidity();
    } else {
      this.showReasonForDelay = false;
    }
  }

  public override afterOnDestroy(): void {
    // afterOnDestroy
  }

  postCancelConfirmation(): void {
    this.loadSpinner = false;
    this.dashboardService.getReloadDashboardGrid(true);
  }

  postSubmitConfirmation(): void {
    this.loadSpinner = false;
    this.dashboardService.getReloadDashboardGrid(true);
    this.close.next();
  }
  saveDetails(): Observable<SudentRelatedEventsModel> {
    this.loadSpinner = true;
    const submitSudentRelatedEventsModel: SubmitCaseClosingModel =
      new SubmitCaseClosingModel({
        ...this.form.value,
        eventType: this.selectedAction,
      });
    submitSudentRelatedEventsModel.studentSK = this.studentSk;
    submitSudentRelatedEventsModel.personSk = this.userDetails?.personSk;
    return this.service.submitCaseCloseEvent(submitSudentRelatedEventsModel);
  }

  addReasonForDelay(): void {
    const newReason: FormGroup = this.fb.group({
      reasonForDelayId: [null, Validators.required],
      description: ['', Validators.required],
      caseActionSk: [this.referralSk],
      stageId: [10],
    });

    this.reasons.push(newReason);

    newReason.get('reasonForDelayId').updateValueAndValidity();
    newReason.get('description').updateValueAndValidity();
    this.form.updateValueAndValidity();
  }

  get canSaveDraft(): boolean {
    return !this.form.valid;
  }

  get canSubmit(): boolean {
    return false;
  }

  get reasons(): FormArray {
    return this.form?.get('reasonForDelays') as FormArray;
  }

  clearRequiredValidators(control: FormControl): void {
    control.reset();
    control.clearValidators();
    control.setErrors(null);
    control.updateValueAndValidity();
  }
}
